import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { creditAllocationRefundAPI } from 'api/credit'
import {
  creditAllocationRefundTxFormTypes,
  creditAllocationRefundTxFormSubmitValuesTypes,
  creditAllocationRefundTxFormSubmitActionsTypes,
} from 'types/creditAllocationRefundTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const CREDITALLOCATIONREFUNDTXINITVAL: creditAllocationRefundTxFormTypes = {
  creditValue: 0,
  externalTransactionId: '',
  ident: '',
  cashier: '',
  guid: '',
  transactionDate: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
  pin: '',
}

export const useCreditAllocationRefundTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: creditAllocationRefundTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitCreditAllocationRefundTx: (
    values: creditAllocationRefundTxFormSubmitValuesTypes,
    actions: creditAllocationRefundTxFormSubmitActionsTypes
  ) => void
  handleClearCreditAllocationRefundTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<creditAllocationRefundTxFormTypes>({
      ...CREDITALLOCATIONREFUNDTXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: '',
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitCreditAllocationRefundTx = useCallback(
    async (
      values: creditAllocationRefundTxFormSubmitValuesTypes,
      actions: creditAllocationRefundTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        await creditAllocationRefundAPI(values)
        toast.success('Credit Allocation refund successful.')
        onCloseModal()
        // actions.setSubmitting(false)
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearCreditAllocationRefundTx = useCallback(() => {
    initialValuesSet({ ...CREDITALLOCATIONREFUNDTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitCreditAllocationRefundTx,
    handleClearCreditAllocationRefundTx,
  }
}
